<form class="socket-search-form">
  <mat-form-field class="socket-search-field {{ matFormFieldClass }}" [ngClass]="" [floatLabel]="floatingLabel">
    <mat-label>{{ placeholder }}</mat-label>
    <input
      type="text"
      matInput
      #autoComplete
      [matAutocomplete]="auto"
      (keyup)="onSearch($event)"
      (blur)="onBlur()"
      [formControl]="searchInputCtrl"
      name="search" />
    @if (searchInputCtrl.value) {
      <button matSuffix mat-icon-button type="button" class="toolbar-button" (click)="clearSearch($event)">
        <mat-icon>close</mat-icon>
      </button>
    }
    @if (hint) {
      <mat-hint>{{ hint }}</mat-hint>
    }
    <mat-error>{{ errorMessage }}</mat-error>
  </mat-form-field>
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    [hideSingleSelectionIndicator]="true"
    (optionSelected)="selectItem($event)">
    @for (item of searchItems; track item) {
      <mat-option [value]="item">
        <ng-template
          [ngTemplateOutlet]="templateRef"
          [ngTemplateOutletContext]="{
            $implicit: { item, searchInputCtrl }
          }"></ng-template>
      </mat-option>
    }
  </mat-autocomplete>
</form>
